import React, { useState } from "react";
import { getSearchResultApi } from "../../Api/ClientServices";
import Style from "./SearchHome.module.css";
import { Link } from "react-router-dom";
import { errorToast } from "../../Toast/Toast";

const SearchHome = () => {
  const [searchValue, setSearchValue] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSearchPart, setShowSearchPart] = useState(false);

  // Debounce function
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Function to handle search and API call
  const getSearchProduct = async (value) => {

    if (value.trim() === "") {
      setSearchValue([]);
      setShowSearchPart(false);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);  // Set loading state before the API call
    getSearchResultApi(value, (succ, res) => {
      setIsLoading(false);  // Stop loading state after API call is complete

      if (succ) {
        if (res.status === 0 || res.product===null || res.status===-2) {
          setSearchValue([]);
          setShowSearchPart(true);
        } else {
          setSearchValue(res.product);
          setShowSearchPart(true);
        }
      } else {
        errorToast(res.message);
        setSearchValue([]);
        setShowSearchPart(false);
      }
    });
  };

  // Debounced version of getSearchProduct
  const debouncedSearch = debounce(getSearchProduct, 800);

  // Helper function to generate a random number for image caching
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  return (
    <div className={Style.searchHolder}>
      <input
        className={Style.search}
        placeholder={"جستجو..."}
        onChange={(e) => debouncedSearch(e.target.value)}
        type={"text"}
      />

      {isLoading && <p className={Style.searchResult}>درحال جست و جو!</p>}

      {!isLoading && showSearchPart && searchValue.length === 0 ? (
        <p className={Style.searchResult}>موردی یافت نشد!</p>
      ) : (
        <ul className={Style.searchResult} style={{opacity:!isLoading && showSearchPart?1:0}}>
          {searchValue?.sort((a,b)=>b.score-a.score).map((item, index) => (
            <Link
              to={{
                pathname: `/product/${item.id}/${item.supplier_id}`,
                state: item.id,
              }}
              className={Style.resultItem}
              key={index}
            >
              <div className={Style.imgHolder}>
                <img
                  src={`https://cdn.barest.ir/product/m/${item.id}.jpg?${randomNumberInRange(1, 1000000000000)}`}
                  alt="محصول"
                />
              </div>
              <div className={Style.productInfo}>
                <h3 className={Style.productName}>{item.name}</h3>
                <div className={Style.priceHolder}>
                  {item.off_price !== 0 && (
                    <h3 className={Style.offPrice}>{item.off_price}تومان</h3>
                  )}
                  <h3 className={item.off_price === 0 ? Style.price : Style.ofprice}>
                    {item.price}تومان
                  </h3>
                </div>
              </div>
            </Link>
          ))}
          {/* <div className={Style.opacityPart}></div> */}
        </ul>
      )}
    </div>
  );
};

export default SearchHome;
